import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api, axiosConfig } from '../config'
import { ErrorWithResponse } from '../types'
import { toast } from 'react-toastify'

export interface ISendUTRProps {
  utr: string
}

const sendImg = async (data: ISendUTRProps) => {
  const config = axiosConfig(data)
  return await api.post('/operations/utr', config.formdata, config.config)
    .then((res) => res.data)
}

export const useSendUTR = () => {
  const queryClient = useQueryClient()

  return useMutation(sendImg, {
    onSuccess: () => {
      queryClient.invalidateQueries(['data'])
    },
    onError: (err: ErrorWithResponse) => {
      toast.error(err.response.data && err.response.data.description)
    },
  })
}
